@if (isLive() === true) {
  <span
    [class]="'px-2 py-1 text-xs font-medium text-white bg-gradient-to-r from-[rgb(197,164,223)] to-[rgb(235,100,100)] rounded-full animate-pulse flex-shrink-0 ' + additionalClasses()"
  >
    {{ label() }}
  </span>
}
